import React, { useCallback } from 'react';

import { BodyComponent } from 'features/menu/components/product-detail/product-detail-flow/dialogs/body-component';
import { logConfirmationDialogCta } from 'features/menu/components/product-detail/product-detail-flow/dialogs/utils';
import { useProductWizardContext } from 'features/menu/components/product-wizard';
import { ProductWizardStep } from 'features/menu/components/product-wizard/types';
import { useProductWizardFlow } from 'features/menu/components/product-wizard/use-product-wizard-flow';

import ConfirmDialog from 'components/confirm-dialog';
import { t } from 'state/intl/translations';

export const CloseConfirmationDialog = () => {
  const { closeWizard, currentFlowStep } = useProductWizardFlow();

  const {
    showCloseDialog,
    setShowCloseDialog,
    restoreSlotsSelectionSnapshot,
  } = useProductWizardContext();
  const heading = t('productDetailCloseHeading');
  const content = t('productDetailCloseContent');

  const confirmLabel = t('leaveNow');
  const cancelLabel = t('continueCustomizing');
  const shouldShowDialog =
    showCloseDialog && currentFlowStep.step !== ProductWizardStep.ProductCustomization;

  const onConfirm = useCallback(() => {
    restoreSlotsSelectionSnapshot();
    logConfirmationDialogCta(confirmLabel);
    setShowCloseDialog(false);
    closeWizard();
  }, [restoreSlotsSelectionSnapshot, setShowCloseDialog, confirmLabel, closeWizard]);

  const onCancel = useCallback(() => {
    logConfirmationDialogCta(cancelLabel);
    setShowCloseDialog(false);
  }, [cancelLabel, setShowCloseDialog]);

  return (
    <ConfirmDialog
      showDialog={shouldShowDialog}
      modalAppearanceEventMessage="Product Detail Close Dialog"
      bodyComponent={<BodyComponent heading={heading} content={content} />}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
